import {money, objects, sorting} from "@atttomyx/shared-utils";
import {ID_ANONYMOUS} from "../constants";

const sortByDateDesc = (a, b) => sorting.sortByFieldDesc(a, b, "date");
const sortByCategory = (a, b) => sorting.sortByField(a, b, "category");
const sortByType = (a, b) => sorting.sortByField(a, b, "type");

export const sortOfferings = sorting.getCompositeSorter([sortByDateDesc, sortByCategory, sortByType, sorting.sortByUpdatedDesc]);

export const sanitizeAnonymous = (offering) => {
    const sanitized = objects.deepCopy(offering);

    sanitized.nodeId = ID_ANONYMOUS;

    return sanitized;
};

export const sumByGrouping = (offerings, field) => {
    const grouped = {};

    offerings.forEach(offering => {
        const group = offering[field];

        if (group && offering.amount) {
            const existing = grouped[group];
            const additional = offering.amount;

            grouped[group] = existing
                ? money.add([existing, additional])
                : additional;
        }
    });

    return grouped;
};
